import { UserContext } from "../lib/UserContext";
import { useContext } from "react";
import { Link } from "react-router-dom";
import pb from "lib/pocketbase";
import { useNavigate } from "react-router-dom";
import { zdConfig } from "zdConfig";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { Dropdown, Tabs, Tab } from "react-bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";

export default function Navbar() {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-dark d-flex justify-content-between bg-dark text-light align-items-center">
      {" "}
      <div className="container-fluid d-flex align-items-center">
        <ul className="nav d-flex align-items-center">
          <li className="">
            <Link className="navbar-brand btn btn-dark text-light" to="/">
              Zendash{" "}
              <span className="badge bg-transparent border ">
                {zdConfig.version}
              </span>
            </Link>
          </li>
        </ul>
        <ul className="nav d-flex align-items-center text-light">
          {user && (
            <>
              {" "}
              {/* <li className="">
                <Link className="btn btn-dark text-light" to="/test">
                  <em>Test</em>
                </Link>
          </li> */}
              <li className="px-2">{user.name}</li>
              <li className="">
                <Link className="btn btn-dark text-light" to="/settings">
                  Settings
                </Link>
              </li>
              <li className="">
                <button
                  className="btn btn-dark text-light"
                  onClick={() => {
                    setUser(null);
                    pb.authStore.clear();
                    navigate("/login");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-box-arrow-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                    />
                  </svg>
                </button>
              </li>{" "}
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}
